import { Directive, OnInit, ElementRef } from '@angular/core';

/*
	The purpose of this is to remove the containing custom HTML tag.
	For example, if I make a small element:
	<example-el>
		<input />
	</example-el>
	And I try to inline it with other inputs, it won't inherit the styles
	of its parent. So you end up with really weird inconsistent styles.
	So all this does is get rid of the containing HTML tag. So
	<example-el rpsharedRemoveHost>
		<input />
	</example-el>
	Turns into just:
		<input />
	So is easily inlined with whatever elements you stick it with (and inherits
	styles from the parent element).
*/

@Directive({
	selector: '[rpsharedRemoveHost]',
})
export class RemoveHostDirective implements OnInit {
	constructor(private el: ElementRef) {}

	ngOnInit() {
		const nativeElement: HTMLElement = this.el.nativeElement,
			parentElement: HTMLElement = nativeElement.parentElement;

		while (nativeElement.firstChild) {
			parentElement.insertBefore(nativeElement.firstChild, nativeElement);
		}

		parentElement.removeChild(nativeElement);
	}
}
